<!-- start: SESSION CARD -->
<div class="col-12 sm:col-12 md:col-12 lg:col-8 px-0 pt-3 pb-0">
    <app-session-card *ngIf="sessionHeader.showSessionCard"></app-session-card>
</div>
<!-- start: SESSION CARD -->

<!-- start: SESSION WIZARD -->
<app-session-wizard *ngIf="sessionHeader.wizardActiveIndex !== undefined" [activeIndex]="sessionHeader.wizardActiveIndex"></app-session-wizard>
<!-- end: SESSION WIZARD -->